import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React from "react";
import { Switch } from "react-materialize";
import { commonState, store } from "../../../store";

import { DriversRow } from "../../../api";
import { MonthDayPicker } from "../../../components/datepickers/MonthDayPicker";
import { DriverPulldown } from "../../../components/driverPulldown";
import { OfficePullDown } from "../../../components/officePullDown";
import {
    filterDriver,
    filterEndDate,
    filterNeedGuidance,
    filterOffice,
    filterStartDate,
} from "../../../services/reserve/shifts_filter";
import { selectShiftsReport } from "../../../services/reserve/shifts_report";
import { fontSizes } from "../../../theme";
import { Props, Table } from "./Table";

interface SearchBarProps {
    commonState: commonState;
    selectedOfficeId?: number;
}

const SearchBar: React.FC<SearchBarProps> = (props: SearchBarProps) => {
    const click_search = (ev: any) => {
        selectShiftsReport();
    };

    const set_start_date = (ev: any) => {
        filterStartDate(ev as string);
    };

    const set_end_date = (ev: any) => {
        filterEndDate(ev as string);
    };

    const set_guidance_selected = (ev: any) => {
        filterNeedGuidance(ev.target.checked);
    };

    function onChangeDriver(driver: DriversRow | null) {
        filterDriver(driver);
    }

    const onClearDriver = () => {
        filterDriver(null);
    };

    // ASK 初期化や検索を押すとここが５回呼ばれてその都度描画している？
    // ログイン時は１７回呼ばれている
    return (
        <Box
            id="SearchBarContainer"
            sx={{ p: 2, display: "flex", alignItems: "end" }}
        >
            <Box>
                <OfficePullDown
                    useAllOfficeIds={true}
                    selectedOfficeId={props.selectedOfficeId}
                    onChange={filterOffice}
                />
            </Box>
            <Box sx={{ pl: 3 }}>
                <DriverPulldown
                    selectedDriver={props.commonState.selectedDriver}
                    onChange={onChangeDriver}
                    onClear={onClearDriver}
                    driverCompleteData={props.commonState.driverNames}
                    initWithNull={false}
                />
            </Box>
            <Box
                sx={{
                    pl: 3,
                }}
            >
                <MonthDayPicker
                    initialDate={store.getState().reserveShifts.startDate}
                    onChangeMethod={(ev) => {
                        set_start_date(ev);
                    }}
                />
            </Box>
            <Box sx={{ pr: 3, pl: 3, pb: 1.5, fontSize: fontSizes.xxlarge }}>
                ~
            </Box>
            <Box>
                <MonthDayPicker
                    initialDate={store.getState().reserveShifts.endDate || ""}
                    onChangeMethod={(ev) => {
                        set_end_date(ev);
                    }}
                />
            </Box>
            <Box style={{ margin: "3px" }}>
                <Button
                    variant="contained"
                    onClick={async (ev) => {
                        set_end_date(null);
                    }}
                    color="info"
                    size="small"
                >
                    クリア
                </Button>
            </Box>
            <Box style={{ padding: "10px", display: "inline-block" }}>
                <Switch
                    onChange={(ev) => {
                        set_guidance_selected(ev);
                    }}
                    id="checked-search-check"
                    onLabel="要指導あり"
                    offLabel=""
                    checked={store.getState().reserveShifts.needGuidanceOnly}
                />
            </Box>
            <Box sx={{ pl: 4 }}>
                <Button
                    variant="contained"
                    onClick={async (ev) => {
                        click_search(ev);
                    }}
                    color="primary"
                    size="medium"
                >
                    検索
                </Button>
            </Box>
        </Box>
    );
};

export const Container: React.FC<Props> = (props: Props) => {
    const componentDidMount = () => {
        const _i = document.getElementsByClassName("autocomplete");
        const inpts = [...(_i as any)];
        inpts.forEach((el: HTMLInputElement) => {
            el.autocomplete = "off";
        });
    };

    componentDidMount();

    return (
        <Box>
            <SearchBar
                commonState={props.commonState}
                selectedOfficeId={props.reserveShifts.officeId}
            />
            <Table
                commonState={props.commonState}
                reserveShifts={props.reserveShifts}
            />
        </Box>
    );
};
